import axios from 'axios';

const getHeaders = key => {
  return {
    'Content-Type': 'application/json',
    'X-API-KEY': key
  };
};

const apis = {
  FORMS: {
    host: process.env.FORMS_API,
    header: getHeaders(process.env.FORMS_API_KEY)
  },
  PHONE: {
    host: 'fpcezwyuii.execute-api.us-east-1.amazonaws.com',
    header: getHeaders(process.env.PHONE_API_KEY)
  },
  ESIGNATURE: {
    host: 'yps4lthhp8.execute-api.us-east-1.amazonaws.com',
    header: getHeaders(process.env.ESIGNATURE_API_KEY)
  }
};

/* Send code to phone */
export const sendCodeService = async data => {
  return await axios.post(`https://${apis.PHONE.host}/dev/code`, data, {
    headers: apis.PHONE.header
  });
};

/* Check verification code */
export const verifyCodeService = async data => {
  return await axios.post(`https://${apis.PHONE.host}/dev/verify`, data, {
    headers: apis.PHONE.header
  });
};

/* Send encrypted data */
export const signUpService = async data => {
  return await axios.post(`https://${apis.FORMS.host}/kitsignup`, data, {
    headers: apis.FORMS.header
  });
};

/* Get document id */
export const generateDocIdService = async data => {
  return await axios.post(`https://${apis.ESIGNATURE.host}/dev/create`, data, {
    headers: apis.ESIGNATURE.header
  });
};

/* Send agreement */
export const updateSignedConsentService = async data => {
  return await axios.post(
    `https://${apis.FORMS.host}/updateSignedConsent`,
    data,
    {
      headers: apis.FORMS.header
    }
  );
};

/* Tracking 
   ALLOWED_EVENTS = ["VISIT", "START", "SUBMIT", "VERIFY_PHONE", "SIGNED_CONSENT"]
*/
export const trackStatsService = async data => {
  return await axios.post(`https://${apis.FORMS.host}/trackStats`, data, {
    headers: apis.FORMS.header
  });
};